import type { PlcMonitorFields } from "../../../contracts/plc-monitor.js";

export function plcMonitorPresentation(value: PlcMonitorFields | null, connected: boolean, now: number) {
  const fresh = (time: string | undefined) => connected && !!time && Number.isFinite(Date.parse(time)) && Math.abs(now - Date.parse(time)) <= 10_000;
  const faultKnown = typeof value?.machineFault === "boolean" && value.faultCoil === 10;
  const speed = value?.sensorSpeedPerMinute;
  const speedKnown = typeof speed === "number" && Number.isInteger(speed) &&
    speed >= 0 && speed <= 0xffffffff && value?.sensorSpeedRegister === 22;
  const faultFresh = faultKnown && fresh(value?.faultMeasuredAt);
  const speedFresh = speedKnown && fresh(value?.sensorSpeedMeasuredAt);
  return {
    fault: faultKnown ? `${value.machineFault ? "Arıza var" : "Arıza yok"}${faultFresh ? "" : " · son ölçüm"}` : "Ölçüm bekleniyor",
    speed: speedKnown ? `${speed.toLocaleString("tr-TR")} /dk${speedFresh ? "" : " · son ölçüm"}` : "Ölçüm bekleniyor",
    faultFresh, speedFresh,
    faultActive: faultKnown && value.machineFault,
  };
}
